import { TrendData } from '../../entities/trend-data';

export class TrendDummyData{
    public static trendData1:TrendData[] = [
        new TrendData(
            "00000000-0000-0000-0000-000000000001",
            2016,
            28,
            27,
            26,
            25,
            24,
            23,
            1,
            5,
            11,
            33,
            14,
            38,
            0,
            33,
            28,
            29,
            18,
            31,
            30),
            
        new TrendData(
            "00000000-0000-0000-0000-000000000001",
            2015,
            25,
            19,
            40,
            27,
            28,
            31,
            0,
            3,
            9,
            31,
            24,
            32,
            2,
            28,
            30,
            21,
            23,
            34,
            29),
        
        new TrendData(
            "00000000-0000-0000-0000-000000000001",
            2014,
            39,
            26,
            36,
            28,
            12,
            21,
            5,
            5,
            14,
            24,
            25,
            17,
            2,
            25,
            26,
            19,
            34,
            31,
            40),
        
        new TrendData(
            "00000000-0000-0000-0000-000000000001",
            2013,
            25,
            33,
            36,
            21,
            25,
            29,
            3,
            6,
            9,
            25,
            30,
            32,
            1,
            25,
            29,
            33,
            31,
            19,
            21),
        
        new TrendData(
            "00000000-0000-0000-0000-000000000001",
            2012,
            26,
            24,
            29,
            30,
            35,
            25,
            3,
            2,
            11,
            29,
            25,
            20,
            5,
            23,
            27,
            20,
            30,
            23,
            28),
        
        
    ]
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/trend-dummy-data.ts